import { useEffect } from "react";
import {
  BookOpen,
  Cpu,
  Library,
  Lock,
  Wifi,
  Server,
  Shield,
} from "lucide-react";
import {
  Button,
  Card,
  List,
  ListItem,
  ListItemDecorator,
  Typography,
} from "@mui/joy";

export default function AcademySection({ dark }: { dark: boolean }) {
  useEffect(() => {}, [dark]);

  return (
    <section
      id="academy"
      className="w-full py-12 md:py-24 lg:py-32 hide-scrollbar"
      style={{ backgroundColor: dark ? "#1f2937" : "white" }}
    >
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center justify-between">
          {/* Left Content */}
          <div className="flex flex-col justify-center space-y-6 lg:max-w-[50%]">
            <h2
              className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl"
              style={{ color: dark ? "#38BDF8" : "#7B3FE4" }}
            >
              HackTheWay Academy
            </h2>
            <Typography level="title-lg" className="max-w-[600px]">
              Elevate your security skills across IT, IoT, and OT domains with
              our comprehensive learning platform. From foundational concepts to
              advanced techniques, HackTheWay Academy prepares you for the
              diverse challenges in modern cybersecurity.
            </Typography>
            <div className="flex flex-col sm:flex-row gap-4">
              {/* Browse Courses Button */}
              <Button
                size="lg"
                color="primary"
                className="text-white bg-[#7B3FE4] hover:bg-[#5e2bbd]"
                variant="solid"
                onClick={() => {
                  window.open("https://academy.hacktheway.com", "_blank");
                }}
              >
                <Library className="mr-2 h-4 w-4" />
                Browse Courses
              </Button>
              {/* Start Learning Button */}
              <Button
                size="lg"
                variant="outlined"
                style={{
                  color: dark ? "#38BDF8" : "#7B3FE4",
                  borderColor: dark ? "#38BDF8" : "#7B3FE4",
                }}
                onClick={() => {
                  window.open("https://academy.hacktheway.com/login", "_blank");
                }}
              >
                <Cpu className="mr-2 h-4 w-4" />
                Start Learning
              </Button>
            </div>
          </div>

          {/* Right Content */}
          <div className="w-full lg:max-w-[40%]">
            <Card
              className="p-6 shadow-lg"
              style={{ backgroundColor: dark ? "#111827" : "#f9fafb" }}
            >
              <Typography
                level="h3"
                className="mb-1"
                style={{ color: dark ? "#38BDF8" : "#7B3FE4" }}
              >
                Featured Courses
              </Typography>
              <List className="space-y-4">
                <ListItem>
                  <ListItemDecorator>
                    <Lock className="h-4 w-4" style={{ color: dark ? "#38BDF8" : "#7B3FE4" }}/>
                  </ListItemDecorator>
                  <Typography level="title-lg">Web Application Security Fundamentals</Typography>
                </ListItem>
                <ListItem>
                  <ListItemDecorator>
                    <Wifi className="h-4 w-4" style={{ color: dark ? "#38BDF8" : "#7B3FE4" }}/>
                  </ListItemDecorator>
                  <Typography  level="title-lg">
                    IoT Device Security and Penetration Testing
                  </Typography>
                </ListItem>
                <ListItem>
                  <ListItemDecorator>
                    <Server className="h-4 w-4" style={{ color: dark ? "#38BDF8" : "#7B3FE4" }}/>
                  </ListItemDecorator>
                  <Typography  level="title-lg">
                    OT Security for Industrial Control Systems
                  </Typography>
                </ListItem>
                <ListItem>
                  <ListItemDecorator>
                    <Shield className="h-4 w-4" style={{ color: dark ? "#38BDF8" : "#7B3FE4" }}/>
                  </ListItemDecorator>
                  <Typography  level="title-lg">
                    Advanced Network Security for IT, IoT, and OT
                  </Typography>
                </ListItem>
              </List>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
}
